import client from "../../../../client";
import type { RequestConfig, ResponseErrorConfig } from "../../../../client";
import type {
  DeleteApiDocumentMutationResponse,
  DeleteApiDocumentQueryParams,
  DeleteApiDocument401,
  DeleteApiDocument403,
} from "../../../types/DeleteApiDocument";

export function getDeleteApiDocumentUrl() {
  return `/api/Document` as const;
}

/**
 * {@link /api/Document}
 */
export async function deleteApiDocument(
  params?: DeleteApiDocumentQueryParams,
  config: Partial<RequestConfig> & { client?: typeof client } = {}
) {
  const { client: request = client, ...requestConfig } = config;

  const res = await request<
    DeleteApiDocumentMutationResponse,
    ResponseErrorConfig<DeleteApiDocument401 | DeleteApiDocument403>,
    unknown
  >({
    method: "DELETE",
    url: getDeleteApiDocumentUrl().toString(),
    params,
    ...requestConfig,
  });
  return res;
}
